import { env } from "@/lib/env";

export function setFavicon() {
  const faviconUrl = `${env.ASSETS_BASE_URL}/assets/branding/favicon.png`;

  let link: HTMLLinkElement | null = document.querySelector("link[rel='icon']");

  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }

  link.href = faviconUrl;
}
